module.exports = __webpack_public_path__ + "img/custom-enterprise-popup.ebab3569.svg";